import { applyDecorators } from '@nestjs/common';
import { ApiProperty, ApiPropertyOptional, ApiPropertyOptions } from '@nestjs/swagger';
import { Type } from 'class-transformer';
import { IsObject, IsOptional, ValidateNested } from 'class-validator';
import { BaseDecoratorOptions } from '../types';

export function ApiPropertyObject<T extends { new(...args: any[]): unknown }>(
  type: () => T,
  { isOptional, ...options }: BaseDecoratorOptions<T extends { new(...args: any[]): infer K } ? K : unknown> = {},
): PropertyDecorator {
  const propertyOptions: ApiPropertyOptions = { type: type(), ...options };
  return applyDecorators(
    ...isOptional ? [IsOptional(), ApiPropertyOptional(propertyOptions)] : [ApiProperty(propertyOptions)],
    ValidateNested(),
    IsObject(),
    Type(type),
  );
}
